import { render, staticRenderFns } from "./StyleDialogStyleTab.vue?vue&type=template&id=5d2c0dc2&scoped=true&"
import script from "./StyleDialogStyleTab.vue?vue&type=script&lang=js&"
export * from "./StyleDialogStyleTab.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogStyleTab.vue?vue&type=style&index=0&id=5d2c0dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c0dc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VForm})
